import React, { useState, useEffect, useContext } from 'react'
// import CssBaseline from '@material-ui/core/CssBaseline'
import TeamTableMaterialUI from '../components/CashCrewForms/TeamTableMaterialUI'
import Footer from '../components/Footer';
import NavbarHeader from '../components/NavbarHeader';
import { Account } from '../components/Accounts'

function CashCrew() {
    const [isOpen, setIsOpen] = useState(false);

    const toggle = () => {
        setIsOpen(!isOpen);
    };

    return (
        <Account>
            <NavbarHeader toggle={toggle} />
            <TeamTableMaterialUI />
            <Footer />
        </Account>
    );
}

export default CashCrew;